<!--
 * @Author: x x
 * @Date: 2024-04-12 22:30:32
 * @LastEditors: x x
 * @LastEditTime: 2024-06-26 20:45:08
 * @FilePath: \vue2-assioc-cms-admin\src\view\devise-page\right-config\right-config.vue
-->
<template>
  <div class="right-config">
    <div v-for="(item, key) in componentList" :key="key">
      <component v-if="item.index === index" :is="item.name"></component>
    </div>
  </div>
</template>

<script>
import com from './components/index'
export default {
  name: 'right-cofig',
  props: {
    index: {
      type: [Number],
      default: null
    }
  },
  components: {
    ...com
  },
  data () {
    return {
      componentList: [],
      query: {},
      search: {},
      diyDom: {},
      diyData: {},
      apiData: {}
    }
  },
  methods: {
    getComponentList () {
      this.componentList = [
        {
          name: com.c_noticebar,
          index: 1
        },
        {
          name: com.c_banner,
          index: 2
        },
        {
          name: com.c_menu,
          index: 3
        },
        {
          name: com.c_notice,
          index: 4
        }, {
          name: com.c_news,
          index: 5
        }, {
          name: com.c_activities,
          index: 6
        }, {
          name: com.c_competitions,
          index: 7
        }
      ]
    }

  },
  mounted () {
    this.getComponentList()
  }
}
</script>
